module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "clearfix"
  }, [_c('titles', {
    class: {
      pageZoom: _vm.pageZoom
    },
    attrs: {
      "vipState": _vm.vipState
    }
  }), _vm._v(" "), _c('full-page', {
    ref: "fullpage",
    attrs: {
      "options": _vm.options,
      "id": "fullpage"
    }
  }, [_c('div', {
    staticClass: "section"
  }, [_c('headers', {
    class: {
      pageZoom: _vm.pageZoom
    },
    attrs: {
      "vipState": _vm.vipState
    },
    on: {
      "showDialog": _vm.showDialog,
      "showHyxy": _vm.showHyxyDialog
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "section"
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('vip-introduce', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentPage === 1),
      expression: "currentPage === 1"
    }],
    class: {
      pageZoom: _vm.pageZoom
    },
    on: {
      "showDialog": _vm.showDialog
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "section"
  }, [_c('job-privilege', {
    class: {
      pageZoom: _vm.pageZoom
    },
    attrs: {
      "vipState": _vm.vipState
    },
    on: {
      "showDialog": _vm.showDialog,
      "showPrivilDialog": _vm.showPrivilDialog,
      "buyDialog": _vm.buyVipDialog
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "section"
  }, [_c('job-safeguard', {
    class: {
      pageZoom: _vm.pageZoom
    },
    on: {
      "showDialog": _vm.showDialog,
      "showPrivilDialog": _vm.showPrivilDialog,
      "buyDialog": _vm.buyVipDialog
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "section"
  }, [_c('iden-privilege', {
    class: {
      pageZoom: _vm.pageZoom
    },
    on: {
      "showDialog": _vm.showDialog,
      "showPrivilDialog": _vm.showPrivilDialog,
      "buyDialog": _vm.buyVipDialog
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "section"
  }, [_c('vip-card', {
    class: {
      pageZoom: _vm.pageZoom
    },
    on: {
      "showDialog": _vm.showDialog
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "section"
  }, [_c('job-analysis', {
    class: {
      pageZoom: _vm.pageZoom
    },
    attrs: {
      "vipState": _vm.vipState
    },
    on: {
      "showDialog": _vm.showDialog
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "controller"
  }, [_c('ul', [_vm._l((_vm.pageNum), function(index) {
    return _c('li', {
      key: 'controller-' + index,
      staticClass: "controller-item",
      class: {
        current: index === _vm.currentPage + 1
      },
      attrs: {
        "data-index": index
      },
      on: {
        "click": function($event) {
          return _vm.changePage(index, 'pc-cvip-louti-' + _vm.actionType[index - 1])
        }
      }
    }, [_vm._v(_vm._s(index > 10 ? index : '0' + index))])
  }), _vm._v(" "), _c('li', {
    staticClass: "ciecle-svg-wrap"
  }, [_c('div', {
    staticClass: "ciecle-svg"
  }), _vm._v(" "), _c('div', {
    staticClass: "arror-top",
    on: {
      "click": function($event) {
        return _vm.nextPrev('top')
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "arror-down",
    on: {
      "click": function($event) {
        return _vm.nextPrev('down')
      }
    }
  })])], 2)]), _vm._v(" "), (_vm.buyDialog === true) ? _c('BuyDialog', {
    attrs: {
      "cardChoose": _vm.cardChoose
    },
    on: {
      "closeDialog": _vm.closeDialog,
      "showHyxy": _vm.showHyxyDialog
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showHyxy) ? _c('hyxy-dialog', {
    on: {
      "closeDialog": _vm.closeDialog
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showJlzd) ? _c('jlzd-dialog', {
    on: {
      "closeDialog": _vm.closeDialog,
      "buyDialog": _vm.buyVipDialog
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showYpyx) ? _c('ypyx-dialog', {
    on: {
      "closeDialog": _vm.closeDialog,
      "buyDialog": _vm.buyVipDialog
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showWxsx) ? _c('wxsx-dialog', {
    on: {
      "closeDialog": _vm.closeDialog,
      "buyDialog": _vm.buyVipDialog
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showTdtq) ? _c('tdtq-dialog', {
    on: {
      "closeDialog": _vm.closeDialog,
      "buyDialog": _vm.buyVipDialog
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showQzfx) ? _c('qzfx-dialog', {
    on: {
      "closeDialog": _vm.closeDialog,
      "buyDialog": _vm.buyVipDialog
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showWxbp) ? _c('qzbz-dialog', {
    attrs: {
      "vipState": _vm.vipState
    },
    on: {
      "closeDialog": _vm.closeDialog,
      "buyDialog": _vm.buyVipDialog
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showCcaq) ? _c('ccaq-dialog', {
    attrs: {
      "vipState": _vm.vipState
    },
    on: {
      "closeDialog": _vm.closeDialog,
      "buyDialog": _vm.buyVipDialog
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showZskf) ? _c('zskf-dialog', {
    attrs: {
      "vipState": _vm.vipState
    },
    on: {
      "closeDialog": _vm.closeDialog,
      "buyDialog": _vm.buyVipDialog
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showZgbs) ? _c('zgbs-dialog', {
    on: {
      "closeDialog": _vm.closeDialog,
      "buyDialog": _vm.buyVipDialog
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showGrrz) ? _c('grrz-dialog', {
    on: {
      "closeDialog": _vm.closeDialog,
      "buyDialog": _vm.buyVipDialog
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showHjld) ? _c('hjld-dialog', {
    on: {
      "closeDialog": _vm.closeDialog,
      "buyDialog": _vm.buyVipDialog
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a4bab1a8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/index/app/VipNo.vue
// module id = vEX7
// module chunks = 1